import Cookie from '../cookie';
import { KEY_USER_ORIGIN } from '../storage/keys';

export const ORIGIN_SIMPLE = 'simple';
export const ORIGIN_CONTACT = 'contact';
export const ORIGIN_CREATE_OFFER = 'create_offer';
export const ORIGIN_FAVORITE = 'favorite';

/**
 * UserOrigin class
 * Use it when you want to set an origin for the registration of an user
 */
export const UserOrigin = {
  /**
   * Get origin info
   *
   * @return {*}
   */
  get() {
    return Cookie.getJSON(KEY_USER_ORIGIN);
  },

  /**
   * Set an user origin
   *
   * @param name The origin name
   * @param data Extra data about origin if necessary
   */
  set(name, data) {
    if (typeof data === 'undefined') {
      data = {}; // eslint-disable-line no-param-reassign
    }

    const originFormattedData = {};
    originFormattedData[name] = data;
    Cookie.setJSON(KEY_USER_ORIGIN, originFormattedData);
  },

  /**
   * Clear the user origin
   */
  clear() {
    Cookie.remove(KEY_USER_ORIGIN);
  },
};
